<template>
    <!-- <div class="elect-receipt-comp">
        <div class="email">
            <label class="button-font input-label">
                <div class="title">
                    <span class="must-fill">*</span>
                    電子郵件
                </div>
                <span v-show="error.email" class="error-with-title">{{error.email}}</span>
            </label>
            <div class="input-error-group">
                <input :class="{error: error.email}" type="text" v-model="email" placeholder="請輸入電子郵件">
            </div>
            <div class="note">
                飛豬平台響應支持地球環保，並配合政府節能減碳計畫推動，將以 E-MAIL 方式將電子發票寄送至您的電子郵件信箱，請確保E-MAIL 填寫正確。
            </div>
        </div>
    </div> -->
    <div class="elect-receipt-comp  default-wrap">
        <div class="wallet-tool-bar">
            <div class="filter" :class="{ fixed: listIsFixed }">
                <rent-select
                refName="year"
                selectMsg="所有年份"
                @getId="getSelectId"
                border="1px solid #d5dad8"
                bgColor="#fff"
                :setDefault="!filter.year"
                >
                    <ul>
                        <li v-for="(item, index) in einvoiceYear" :key="index" :data-id="item">{{item}}</li>
                    </ul>
                </rent-select>
                <rent-select
                class="select-scroll biz"
                refName="month"
                selectMsg="所有月份"
                @getId="getSelectId"
                border="1px solid #d5dad8"
                bgColor="#fff"
                :setDefault="!filter.month"
                >
                    <ul>
                        <li v-for="n in 12" :key="n" :data-id="n">
                            {{n}} 月份
                        </li>
                    </ul>
                </rent-select>
                <table-search @changeWord="setFilterWord" ></table-search>
            </div>
        </div>
        <div class="table-list receipt">
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="date">發票日期</span>
            <span class="num">發票號碼</span>
            <span class="amount">金額</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <!-- <div v-if="einvoiceList.length != 0 && filterByWord.length == 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div> -->
            <div v-if="isLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if="einvoiceList.length == 0" class="is-empty">
            0 筆資料
            </div>
            <ul v-else>
                <li v-for="(item, index) in filterByWord" :key="index">
                    <span class="date">{{ getFormatDateTime(item.invoiceDate, true) }}</span>
                    <span class="num">{{item.invoiceNumber}}</span>
                    <span class="amount">{{ toCurrency(item.amount) }}</span>
                    <span class="action" @click="getEinvoicePdf(item.invoiceNumber)">下載發票</span>
                </li>
            </ul>
        </div>
        </div>
    </div>
</template>
<script>
import RentSelect from "@/components/bussiness/widges/tools/RentSelect.vue";
import TableSearch from '@/components/widge/TableSearch.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';

import { mapGetters } from "vuex";
export default {
    data () {
        return{
            listIsFixed: false,
            isLoading: true,
            filter: {
                year: '',
                month: '',
                word: ''
            }
        }
    },
    watch: {
        filter: {
            handler: function (val) {
                this.$store.dispatch('getBizEinvoiceList', {year: val.year, month: val.month})
            },
            deep: true,
            immediate: true
        }
    },
    created () {
        this.$store.dispatch('getBizEinvoiceList', {year: '', month: ''})
        .then(()=>{
            this.isLoading = false
        })
        this.$store.dispatch('getBizEinvoiceYear')
    },
    methods: {
        getEinvoicePdf: function (data){
            this.$store.dispatch('getBizEinvoicePDF', data)
        },
        setFilterWord: function (value) {
            this.filter.word = value
        },
        getSelectId: function (value) {
            // console.log(value)
            let targetId = event.target.dataset.id
            if( value.ref == 'year' ){
                this.filter.year = targetId
            }else if( value.ref == 'month'){
                this.filter.month = targetId
            }
        },
        setFilterDefault: function () {
            this.filter = {
                year: '',
                month: '',
                word: ''
            }
        }
    },
    computed: {
        filterByWord: function () {
            return this.einvoiceList.filter((item) => {
                if( this.filter.word ){
                    if( item.invoiceNumber.includes(this.filter.word) ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            einvoiceList: "GET_BIZ_EINVOICE_LIST",
            einvoiceYear: "GET_BIZ_EINVOICE_YEAR"
        })
    },
    components: {
        RentSelect,
        TableSearch,
        tableLoading
    }
}
</script>
<style lang="scss">
    .elect-receipt-comp{
        padding: 0;
        margin-bottom: 200px;
        .wallet-tool-bar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 25px 24px;
            .filter.fixed {
                display: none;
                position: fixed;
                z-index: 50;
                margin-left: 785px;
                background: #fff;
                top: 0px;
                height: 80px;
                align-items: center;
            }
            .filter {
                display: flex;
                .biz-rent-select {
                    width: 216px;
                    box-sizing: border-box;
                    margin-right: 10px;
                }
            }
        }
        .receipt {
            position: relative;
            width: 100%;
            border-radius: 0px;
            border: 0px;
            border-bottom: 1px solid #f0f0f0;
            border-top: 1px solid #f0f0f0;
            .table-list-title .date,
            .table-list-body ul li .date {
                width: 112px;
                margin-right: 248px;
            }
            .table-list-title .num,
            .table-list-body ul li .num {
                width: 80px;
                margin-right: 210px;
            }
            .table-list-title .amount,
            .table-list-body ul li .amount {
                width: 105px;
                text-align: right;
                margin-right: 266px;
            }
            .table-list-body ul li .action {
                color: #ff9275;
                cursor: pointer;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/settingCenter/electReceipt/electReceiptComp.vue